import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule } from '../../../../../config/config.module';
import { PorletCabeceraComponent } from './porlet-cabecera.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
	imports: [
		CommonModule,
		ConfigModule,
		MatProgressSpinnerModule,
		MatProgressBarModule
	],
	declarations: [PorletCabeceraComponent],
	exports: [PorletCabeceraComponent]
})
export class PortletCabeceraModule {}
